<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="Processos" :items='questions' :key-form='keyForm'
        prev="/pessoas/formulario" next="/cliente" />
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import Questions from './Questions';

/* eslint-disable max-len */
export default {
  name: 'process-form',
  components: { Icon, Questions },
  data() {
    return {
      keyForm: 'process',
      questions: [
        { field: 'td_tech', title: 'O departamento comercial utiliza a tecnologia para aumentar resultados, seja através de novas ferramentas, discurso de vendas aprimorado ao consumidor ou controle de processo feito digitalmente.' },
        { field: 'td_mkt', title: 'O marketing da empresa ganhou escalabilidade e previsibilidade com ações digitais, gerando leads qualificados e os nutre de forma automatizada até a chegada ao comercial.' },
        { field: 'td_hr', title: 'O RH ganhou agilidade com processos digitais, automatizando tarefas de processos seletivos, análises de performance, folhas de pagamento, dentre outras.' },
        { field: 'td_finance', title: 'O departamento financeiro utiliza tecnologia de maneira eficaz para redução de custos, agilidade em processos, melhor gestão financeira da empresa, dentre outras benéfices.' },
        { field: 'td_it', title: 'O departamento de TI tem genuína preocupação em ir além do "básico" em TI, atuando de forma a reduzir custos e ganhar agilidade em todos os setores da empresa através da tecnologia e novas metodologias (DevOps), sendo o catalizador da transformação digital na empresa.' },
        { field: 'td_legal', title: 'O departamento jurídico / administrativo reduziu consideravelmente seu esforço humano com o uso da tecnologia em tarefas burocráticas como emissão de relatórios, lançamento em sistemas, controle de documentos, dentre outras.' },
        { field: 'td_goal_setting', title: 'A empresa possui metas claras com foco no digital para cenários em curto, médio e longo prazo.' },
        { field: 'td_risk_profile', title: 'A empresa é adepta a riscos - ou seja, busca se adaptar às mutações do mercado e do consumidor independente de suas operações atuais.' },
        { field: 'td_change', title: 'A empresa implementa mudanças, independente de sua magnitude, de forma ágil.' },
        { field: 'td_tooling', title: 'A empresa disponibiliza as ferramentas digitais ideais para o desenvolvimento das funções de cada colaborador.' },
        { field: 'td_automation', title: 'A empresa tem obtido sucesso na redução de trabalhos extremamente manuais realizados por pessoas da equipe.' },
        { field: 'td_tech_inovation', title: 'A empresa busca constantemente novas tecnologias para otimizar seus processos.' },
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 3);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProcessForm.vue